export default {
  'Start at': 'Inizia da',
  'Set to current time': "Imposta l'ora corrente",
  'Audio volume': 'Volume audio',
  'Video volume': 'Volume video',
  'Trim audio': "Taglia l'audio",
  'Audio will end with the video': "L'audio terminerà con il video.",
  'Trim': 'Taglia',
}